import React, { useState, useEffect } from 'react';
import { collection, doc, setDoc, updateDoc } from 'firebase/firestore';
import { storage } from '../firebase';
import { getAuth, updateProfile } from 'firebase/auth';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { getUserDetails, updateUserDetails } from '../utils/FirebaseFunctions';
import toast from 'react-hot-toast';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';

export const Profile = () => {
  const auth = getAuth();
  const user = auth?.currentUser;
  const [displayName, setDisplayName] = useState('');
  const [email, setEmail] = useState(user?.email || '');
  const [address, setAddress] = useState('');
  const [phoneNumber, setPhoneNumber] = useState(null);
  const [profilePhoto, setProfilePhoto] = useState(null);
  const [loading, setLoading] = useState(false);
  const [photoURL, setPhotoURL] = useState('');
  const [docID, setDocID] = useState('');

  useEffect(() => {
    getUserDetails(user?.uid).then(resp => {
      console.log(resp)
      setDisplayName(resp[0]?.name || '');
      setEmail(resp[0]?.email || '');
      setAddress(resp[0]?.address || '');
      setPhotoURL(resp[0]?.photoURL || '');
      setDocID(resp[0]?.id || '');
      setPhoneNumber(resp[0]?.phoneNumber || '');
    })
  }, [user?.uid]);

  const handleUpdateProfile = async () => {
    setLoading(true)
    updateUserDetails(docID, {
      name: displayName,
      address: address,
      phoneNumber: phoneNumber,
      photoURL: profilePhoto ? await uploadProfilePhoto(profilePhoto) : photoURL
    }).then(resp => {
      console.log(resp)
      setLoading(false);
      toast.success('Profile updated successfully', { duration: 4000, position: 'bottom-center' });
    }).catch(err => {
      toast.error('Profile couldn\'t be updated', { duration: 4000, position: 'bottom-center' });
    })
  };

  const uploadProfilePhoto = async (file) => {
    const storageRef = ref(storage, `profile-photos/${user.uid}`);
    await uploadBytes(storageRef, file);
    return getDownloadURL(storageRef);
  };

  return (
    <div className='w-screen p-4'>
      <div className="w-full p-6 bg-white rounded shadow">
        <h1 className="text-md font-semibold mb-4">Profile Settings</h1>
        <label className="block mb-2">
          <span className="text-gray-700 text-xs">Name:</span>
          <input
            type="text"
            value={displayName}
            onChange={(e) => setDisplayName(e.target.value)}
            className="block w-full mt-1 p-2 border text-xs border-gray-300 rounded focus:outline-none focus:border-blue-500"
          />
        </label>
        <label className="block mb-2">
          <span className="text-gray-700 text-xs">Email:</span>
          <input
            type="email"
            value={email}
            disabled
            onChange={(e) => setEmail(e.target.value)}
            className="block w-full text-xs mt-1 p-2 border border-gray-300 rounded focus:outline-none focus:border-blue-500"
          />
        </label>
        <label className="block mb-2">
          <span className="text-gray-700 text-xs">Phone Number:</span>
          <PhoneInput className={'h-[36px] text-xs mt-2 w-full'} value={phoneNumber} onChange={setPhoneNumber} />
        </label>
        <label className="block mb-2">
          <span className="text-gray-700 text-xs">Address:</span>
          <input
            type="text"
            value={address}
            onChange={(e) => setAddress(e.target.value)}
            className="block w-full mt-1 p-2 text-xs border border-gray-300 rounded focus:outline-none focus:border-blue-500"
          />
        </label>
        <label className="block mb-2">
          <span className="text-gray-700 text-xs">Profile Photo:</span>
          <input
            type="file"
            accept="image/*"
            onChange={(e) => {setProfilePhoto(e.target.files[0]); setPhotoURL(URL.createObjectURL(e.target.files[0]))}}
            className="block mt-1 hidden text-xs"
          />
          <div className='w-full p-5 h-auto min-h-[100px] bg-gray-100 border-gray-300 flex flex-row items-center justify-center border-dashed border-2 rounded-md mt-2 mb-5'>
            {!photoURL && <p className='text-xs text-gray-500'>Upload an image</p>}
            {(photoURL) && (
              <img
                src={photoURL}
                alt="Profile Preview"
                className="mt-2 mb-4 rounded"
                style={{ width: '100%', height: 'auto' }}
              />
            )}
          </div>
        </label>
        <button
          onClick={handleUpdateProfile}
          disabled={loading}
          className="bg-blue-500 text-xs w-full text-white py-3 px-4 rounded hover:bg-blue-600 focus:outline-none focus:shadow-outline-blue active:bg-blue-700"
        >
          {loading ? 'Updating...' : 'Update Profile'}
        </button>
      </div>
      <div className='h-[150px] w-full'></div>
    </div>
  );
};
